import { Reducer } from 'redux'
import _ from 'lodash'
import { Profile, ProfileValidationParameters, ProfileValidationResult, ProfileSearchParameters } from './types'
import * as actions from './actions'

export type ProfileState = Readonly<{
  profiles: Record<string, Profile>
  isLoading: boolean
  count: number
  isValidating: boolean
  isSaving: boolean
  validationResult: ProfileValidationResult | null
  selectedProfile: ProfileValidationParameters | null
  searchParameters: ProfileSearchParameters
}>

export const defaultSearchParams = {
  age: '',
  skin: '',
  breast: '',
  size: '',
  hair: '',
  appearance: '',
  offset: 0,
  currentPage: 1,
  pageSize: 10
}

export const initState: ProfileState = {
  profiles: {},
  isLoading: false,
  count: 0,
  isValidating: false,
  isSaving: false,
  validationResult: null,
  selectedProfile: null,
  searchParameters: defaultSearchParams
}

export const profileReducer: Reducer<ProfileState, actions.ProfileActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: { ..._.keyBy(action.payload.profile, 'id') },
        count: action.payload.count
      }
    case actions.FETCH_PROFILE_INFO:
      return {
        ...state,
        isLoading: true
      }
    case actions.FETCH_PROFILE_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedProfile: action.payload
      }
    case actions.START_PROFILE_VALIDATION:
      return {
        ...state,
        isValidating: true
      }
    case actions.UPDATE_PROFILE_VALIDATION:
      return {
        ...state,
        validationResult: action.payload,
        isValidating: false
      }
    case actions.START_SAVING_PROFILE:
      return {
        ...state,
        isSaving: true
      }
    case actions.SAVING_PROFILE_SUCCESS:
      return {
        ...state,
        isSaving: false
      }
    case actions.UPDATE_SELECTED_PROFILE:
      return {
        ...state,
        selectedProfile: action.payload
      }
    case actions.SET_SEARCH:
      return {
        ...state,
        searchParameters: action.payload
      }
    default:
      return state
  }
}
